/**
 * getAtomType
 * @param $atom .
 * @returns row|element|module|""
 */
export const getAtomType = ($atom: JQuery): string => {
  if ($atom.hasClass('gf_row')) {
    return 'row';
  }
  if ($atom.hasClass('element-wrap')) {
    return 'element';
  }
  if ($atom.hasClass('module-wrap')) {
    return 'module';
  }
  return '';
};
